/**
 * Lightweight Google Analytics (gtag.js) event helper.
 * gtag is bootstrapped in index.html; this module is a safe wrapper so
 * components never touch `window.gtag` directly.
 */

type GtagParams = Record<string, string | number | boolean | undefined>;

export const trackEvent = (eventName: string, params: GtagParams = {}) => {
  try {
    const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
    if (typeof window === 'undefined' || typeof gtag !== 'function') return;
    gtag('event', eventName, params);
  } catch (error) {
    console.warn('[analytics] Failed to send event', eventName, error);
  }
};

/** Track an outbound link click (More Games panel, external promos). */
export const trackOutboundLink = (label: string, url: string, location?: string) => {
  trackEvent('outbound_click', {
    link_label: label,
    link_url: url,
    link_domain: (() => {
      try {
        return new URL(url).hostname;
      } catch {
        return url;
      }
    })(),
    link_location: location,
  });
};

/** Track a page view for SPA route changes. */
export const trackPageView = (path: string, title?: string) => {
  trackEvent('page_view', { page_path: path, page_title: title ?? document.title });
};
